import firebase from 'firebase/app';

export async function getPermittedActionsForUserRole(userRole) {
    // Check if user role exists in the enum
    if (userRole) {
        var db = firebase.firestore();
        var doc = await db
            .collection('roles')
            .doc(userRole)
            .get();
        if (doc.exists) {
            return doc.data();
        } else {
            throw new Error('Invalid user role');
        }
    } else {
        throw new Error('No user role provided');
    }
}
